import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';
import HeaderButtons from './ToggleRailButtons';
import Layout from '../index';
import useScrollDirectionTrigger from '../../hooks/useScrollDirectionTrigger';

const useStyles = makeStyles()(theme => ({
  root: {
    background: palette.gray_1100,
    borderBottom: `1px solid ${palette.gray_800}`,
    alignItems: 'center',
    opacity: 1,
    height: theme.spacing(10),
    visibility: 'visible',
    transition: theme.transitions.create(['height', 'opacity', 'visibility'], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.standard,
    }),
    zIndex: theme.zIndex.appBar + 1,
  },
  hide: {
    height: 0,
    opacity: 0,
    visibility: 'hidden',
  },
}));

export default function MobileHeader({
  children,
  hideRightRailButton = false,
}: {
  children: React.ReactNode;
  hideRightRailButton?: boolean;
}) {
  const { classes, cx } = useStyles();
  const { trigger } = useScrollDirectionTrigger(Layout.MAIN_CONTENT_ID);

  return (
    <Grid
      component="header"
      container
      spacing={0}
      className={cx(classes.root, {
        [classes.hide]: trigger,
      })}
    >
      <Grid item style={{ marginRight: 'auto' }}>
        <HeaderButtons.ToggleLeftRailButton alwaysShow />
      </Grid>
      <Grid item>{children}</Grid>
      <Grid item style={{ marginLeft: 'auto', display: 'flex' }}>
        {!hideRightRailButton && <HeaderButtons.ToggleRightRailButton />}
      </Grid>
    </Grid>
  );
}
